import { useDebounce } from 'use-debounce'

export const useDebouncedSearchProduct = (searchProduct: string): string => {
    const [debouncedSearchProduct] = useDebounce(searchProduct, 300)

    return debouncedSearchProduct
}
